<template>
  <div class="kpi-grid">
    <div v-for="card in cards" :key="card.key" class="card kpi-card">
      <div class="card-body p-3 d-flex align-items-center">
        <div class="kpi-icon me-3" :style="{ backgroundColor: card.tint, color: card.color }">
          <i :class="card.icon" aria-hidden="true"></i>
        </div>
        <div>
          <p class="text-xs text-secondary mb-0">{{ $t(card.label) }}</p>
          <h4 class="mb-0 font-weight-bolder">
            <span v-if="loading && !hasData">—</span>
            <span v-else>{{ format(kpis[card.key]) }}</span>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COLORS, formatNumber } from "./shared";

export default {
  name: "KpiCards",
  props: {
    kpis: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  computed: {
    hasData() {
      return Object.values(this.kpis || {}).some((value) => value > 0);
    },
    cards() {
      const ok = { color: COLORS.green, tint: COLORS.greenTint };
      return [
        { key: "orders_received", label: "key_dashboard_orders_received", icon: "fa fa-shopping-bag", ...ok },
        { key: "orders_shipped", label: "key_dashboard_orders_shipped", icon: "fa fa-truck", ...ok },
        {
          key: "orders_stock_break",
          label: "key_dashboard_orders_stock_break",
          icon: "fa fa-exclamation-triangle",
          color: COLORS.red,
          tint: COLORS.redTint,
        },
        { key: "purchases_pending", label: "key_dashboard_purchases_pending", icon: "ni ni-cart", ...ok },
        { key: "orders_back_pending", label: "key_dashboard_orders_back_pending", icon: "fa fa-reply", ...ok },
      ];
    },
  },
  methods: {
    format(value) {
      return formatNumber(value, this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 1.5rem;
}

.kpi-card {
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
}

.kpi-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  flex-shrink: 0;
}
</style>
